export function getDeleteMessage(value) {
  return `Are you sure you want to permanently delete the note template “${value.name}”?`
}
